module.exports = __webpack_public_path__ + "media/img/vca/nome0-9ae9e09567cda6b83d2fe942a52c5fd4.png";